import styled from 'styled-components';

export const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const PopupContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const TitleIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReasonHeading = styled.h3`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #8B5CF6;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  color: #333;
  cursor: pointer;
  flex: 1;
`;

export const TextAreaLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: #8B5CF6;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
  }

  &::placeholder {
    color: #9CA3AF;
  }
`;

export const SendButton = styled.button`
  background: var(--color-purple-300, #7200E0);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  align-self: flex-end;
  transition: background-color 0.2s;

   &:hover {
    background: #5a00b3;
  }
  &:disabled {
    background-color: #D1D5DB;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #EF4444;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 8px;
`;
